module.exports = __webpack_public_path__ + "static/registration-14c2d0195d02fd1f33d7d73fc7f6a360.png";